import { render } from "./ExportMetricsModal2.vue?vue&type=template&id=2827f492&scoped=true"
import script from "./ExportMetricsModal2.vue?vue&type=script&lang=js"
export * from "./ExportMetricsModal2.vue?vue&type=script&lang=js"

import "./ExportMetricsModal2.vue?vue&type=style&index=0&id=2827f492&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2827f492"]])

export default __exports__